<template>
    <div
        v-if="!editable"
        class="uk-form-row"
    >
        <slot name="read_only">
            {{ option_by_value(value)[labelField] }}
        </slot>
    </div>
    <div
        v-else
        class="uk-form-row"
    >
        <div class="uk-button-group">
            <base-button
                v-for="option in options"
                :key="option[idField]"
                :size="size"
                :class="{'uk-active': value === option[idField], 'uk-margin-small-left':  separated, 'uk-margin-small-right': separated}"
                v-html="option[labelField]"
                @click.prevent="$emit('input', option[idField], name)"
            />
        </div>
        <div
            v-if="!!error"
            :id="`${identifier}-description`"
            aria-live="assertive"
            class="uk-form-help-block uk-text-danger"
        >
            {{ error }}
        </div>
    </div>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

import BaseButton from "./BaseButton"

export default {
    name: "FormRadioButtons",
    mixins: [is_nibnut_component],
    components: {
        BaseButton
    },
    methods: {
        option_by_value (value) {
            return this.options.find(option => `${option[this.idField]}` === `${value}`) || {}
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "name"
        },
        options: {
            type: Array,
            default () {
                return []
            }
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|medium|large)$/i),
            default: "medium"
        },
        required: {
            type: Boolean,
            required: true
        },
        separated: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
